import { getTracking, buildTrackingPayload } from "../helpers/tracking";

export function handleMultiStepBooking(elem) {
    if (!elem) return;

    // Firstly add a class if user lands on booking page
    addBodyClassIfWrapperContainsId(elem);

    function addBodyClassIfWrapperContainsId(el) {
        const wrapper = el.closest('#booking-journey');

        if (wrapper) {
            document.body.classList.add('has-booking-journey');
        }
    }

    // Now run booking functionality
    const getBookingWrapper = document.getElementById('dialog-booking');
    const form = document.getElementById('bookingForm');
    const steps = Array.from(document.querySelectorAll('.form-step'));
    const result = document.getElementById('result');
    const urgentResult = document.getElementById('urgentResult');
    const progressSteps = Array.from(
        document.querySelectorAll('[data-progress-step]')
    );

    const sectorOtherText = document.getElementById('sectorOtherText');
    const sectorOtherError = document.getElementById('sectorOtherError');
    const otherPanel = document.querySelector('[data-other-panel]');

    const postcodeInput = document.getElementById('postcode');
    const calVisitLink = document.getElementById('calVisitLink');
    const calConsultationLink = document.getElementById(
        'calConsultationLink'
    );

    const errorMessage = elem.querySelector('#postcode-error');

    const thankYou = document.getElementById('thankYou');
    const error = document.getElementById('error');
    const saveError = document.getElementById('saveError');

    let currentStep = 1;
    let isSubmitting = false;

    // Track which steps have auto-advanced
    const autoAdvancedSteps = new Set();

    const formState = {
        sector: '',
        sectorLabel: '',
        timeline: '',
        timelineLabel: '',
        postcode: ''
    };

    function resetFormFlow() {
        // Reset native form values
        form.reset();

        // Reset step state
        currentStep = 1;
        isSubmitting = false;
        autoAdvancedSteps.clear();

        // Reset saved journey data
        formState.sector = '';
        formState.sectorLabel = '';
        formState.timeline = '';
        formState.timelineLabel = '';
        formState.postcode = '';

        // Reset step visibility
        steps.forEach((step) => {
            step.hidden = true;
            step.classList.remove('is-active');
        });

        // Reset panels
        form.hidden = false;
        result.hidden = true;
        urgentResult.hidden = true;
        thankYou.hidden = true;
        error.hidden = true;
        saveError.hidden = true;

        result.classList.remove('is-active');
        thankYou.classList.remove('is-active');

        // Reset step 1 conditional panel
        if (otherPanel) {
            otherPanel.hidden = true;
        }

        if (sectorOtherError) {
            sectorOtherError.hidden = true;
        }

        // Reset postcode UI
        if (postcodeInput) {
            postcodeInput.value = '';
        }

        if (errorMessage) {
            errorMessage.hidden = true;
        }

        // Reset Step 5 validation states
        const stepFive = document.querySelector(
            '.form-step[data-step="5"]'
        );

        if (stepFive) {
            const fields = stepFive.querySelectorAll(
                'input, textarea, select'
            );

            fields.forEach((field) => {
                field.removeAttribute('aria-invalid');

                const error = document.getElementById(
                    `${field.id}-error`
                );

                if (error) {
                    error.hidden = true;
                }
            });
        }

        // Reset progress indicators
        updateProgressSteps();

        // Restore wrapper state
        getBookingWrapper?.classList.add('centered-content');

        // Show first step again
        showStep(1);
    }

    /**
     * Build the booking query string.
     *
     * Booking journey values and tracking values are deliberately
     * added as individual URL parameters.
     *
     * This means Cal.com receives:
     *
     * ?sector_key=...
     * &sector_label=...
     * &timeline_key=...
     * &timeline_label=...
     * &postcode=...
     * &landing_url=...
     * &referrer=...
     * &utm_source=...
     * etc.
     *
     * Empty tracking values are omitted.
     */
    function buildQueryString(state) {
        const params = new URLSearchParams();

        // Booking journey data
        params.set('sector_key', state.sector);
        params.set('sector_label', state.sectorLabel);
        params.set('timeline_key', state.timeline);
        params.set('timeline_label', state.timelineLabel);
        params.set('postcode', state.postcode);

        /*
        * Get the latest tracking data at the point
        * the query string is actually built.
        */
        const trackingData = getTracking();

        // Tracking data
        if (trackingData) {
            const trackingParams = [
                'source',
                'medium',
                'landingPage',
                'referrer',
                'utm_source',
                'utm_medium',
                'utm_campaign',
                'utm_term',
                'utm_content',
                'gclid',
                'fbclid',
                'msclkid'
            ];

            trackingParams.forEach((key) => {
                const value = trackingData[key];

                if (
                    value !== null &&
                    value !== undefined &&
                    value !== ''
                ) {
                    const parameterName =
                        key === 'landingPage'
                            ? 'landing_page'
                            : key;

                    params.set(parameterName, value);
                }
            });
        }

        return params.toString();
    }

    function showStep(stepNumber) {
        const previousStep = currentStep;

        // Initial load
        if (previousStep === stepNumber) {
            const panel = document.querySelector(
                `.form-step[data-step="${stepNumber}"]`
            );

            panel.hidden = false;
            panel.classList.add('is-active');

            updateProgressSteps();
            updateNextButtonVisibility();

            return;
        }

        const currentPanel = document.querySelector(
            `.form-step[data-step="${previousStep}"]`
        );

        const nextPanel = document.querySelector(
            `.form-step[data-step="${stepNumber}"]`
        );

        currentStep = stepNumber;

        updateProgressSteps();

        const revealNext = () => {
            if (currentStep === 4) {
                getBookingWrapper.classList.remove(
                    'centered-content'
                );
            } else {
                getBookingWrapper.classList.add(
                    'centered-content'
                );
            }

            nextPanel.hidden = false;

            requestAnimationFrame(() => {
                nextPanel.classList.add('is-active');
                updateNextButtonVisibility();
            });
        };

        currentPanel.classList.remove('is-active');

        currentPanel.addEventListener(
            'transitionend',
            () => {
                currentPanel.hidden = true;
                revealNext();
            },
            { once: true }
        );
    }

    function showThankYou() {
        form.hidden = true;
        result.hidden = true;
        urgentResult.hidden = true;
        thankYou.hidden = false;
        error.hidden = true;
        saveError.hidden = true;
        thankYou.classList.add('is-active');
    }

    function showError() {
        form.hidden = true;
        result.hidden = true;
        urgentResult.hidden = true;
        thankYou.hidden = true;
        error.hidden = false;
        saveError.hidden = true;
    }

    function showSaveError() {
        form.hidden = true;
        result.hidden = true;
        urgentResult.hidden = true;
        thankYou.hidden = true;
        error.hidden = true;
        saveError.hidden = false;
    }

    function buildFullSubmissionPayload() {
        const emailInput = document.getElementById('emailAddress');
        const nameInput = document.getElementById('fullName');
        const companyInput = document.getElementById('company');
        const additionalMessageInput = document.getElementById('additionalMessage');

        const email = emailInput
            ? emailInput.value.trim()
            : '';

        const fullName = nameInput
            ? nameInput.value.trim()
            : '';

        const companyName = companyInput
            ? companyInput.value.trim()
            : '';

        const additionalMessage = additionalMessageInput
            ? additionalMessageInput.value.trim()
            : '';

        const queryString = buildQueryString(formState);

        return {
            // Step data
            sector: formState.sector,
            sectorLabel: formState.sectorLabel,
            timeline: formState.timeline,
            timelineLabel: formState.timelineLabel,
            postcode: formState.postcode,

            // Step 5 data
            email,
            fullName,
            companyName,
            additionalMessage,

            // Tracking data
            tracking: buildTrackingPayload(),

            // Combined output
            queryString: '?' + queryString
        };
    }

    function getSelectedRadioValue(name) {
        return document.querySelector(
            `input[name="${name}"]:checked`
        );
    }

    function updateProgressSteps() {
        progressSteps.forEach((stepEl) => {
            const stepNumber = Number(
                stepEl.dataset.progressStep
            );

            stepEl.classList.remove(
                'is-active',
                'is-complete'
            );

            if (stepNumber < currentStep) {
                stepEl.classList.add('is-complete');
            } else if (stepNumber === currentStep) {
                stepEl.classList.add('is-active');
            }
        });
    }

    function updateNextButtonVisibility() {
        const currentStepEl = steps.find(
            (step) =>
                Number(step.dataset.step) === currentStep
        );

        if (!currentStepEl) return;

        const nextButton =
            currentStepEl.querySelector('[data-next]');

        if (!nextButton) return;

        const stepAction = nextButton.parentElement;

        let shouldShow = false;

        if (currentStep === 1) {
            const selected =
                getSelectedRadioValue('sector');

            if (selected) {
                if (selected.value === 'other') {
                    // Show immediately for "Other"
                    shouldShow = true;
                } else {
                    shouldShow =
                        autoAdvancedSteps.has(1);
                }
            }
        }

        if (currentStep === 2) {
            const selected =
                getSelectedRadioValue('timeline');

            if (selected) {
                shouldShow =
                    autoAdvancedSteps.has(2);
            }
        }

        if (currentStep === 3) {
            shouldShow = !!formState.postcode;
        }

        if (currentStep === 5) {
            getBookingWrapper.classList.add(
                'centered-content'
            );

            stepAction.hidden = false;

            return;
        }

        stepAction.hidden = !shouldShow;
    }

    function validateCurrentStep() {
        if (currentStep === 1) {
            const selected =
                getSelectedRadioValue('sector');

            if (!selected) {
                alert('Please select a sector.');
                return false;
            }

            if (selected.value === 'other') {
                const value =
                    sectorOtherText.value.trim();

                if (!value) {
                    sectorOtherError.hidden = false;
                    sectorOtherText.focus();

                    return false;
                }

                formState.sector = 'other';
                formState.sectorLabel = value;

                sectorOtherError.hidden = true;

                return true;
            }

            formState.sector = selected.value;
            formState.sectorLabel =
                selected.dataset.label;

            return true;
        }

        if (currentStep === 2) {
            const selected =
                getSelectedRadioValue('timeline');

            if (!selected) {
                alert(
                    'Please select how soon you need protection.'
                );

                return false;
            }

            formState.timeline = selected.value;
            formState.timelineLabel =
                selected.dataset.label;

            return true;
        }

        if (currentStep === 3) {
            if (!formState.postcode) {
                postcodeInput.focus();
                errorMessage.hidden = false;

                return false;
            }

            return true;
        }

        return true;
    }

    function tryAutoAdvance(
        stepNumber,
        selected,
        { allowOther = true } = {}
    ) {
        if (!selected) return;

        if (
            !allowOther &&
            selected.value === 'other'
        ) {
            return;
        }

        if (autoAdvancedSteps.has(stepNumber)) {
            return;
        }

        autoAdvancedSteps.add(stepNumber);

        setTimeout(() => {
            showStep(stepNumber + 1);
        }, 100);
    }

    function clearPostcodeError() {
        errorMessage.hidden = true;
    }

    // POSTCODE EVENTS
    postcodeInput.addEventListener(
        'postcode:selected',
        (event) => {
            formState.postcode =
                event.detail.postcode;

            clearPostcodeError();
            updateNextButtonVisibility();
        }
    );

    postcodeInput.addEventListener(
        'postcode:error',
        () => {
            showError();
        }
    );

    postcodeInput.addEventListener(
        'postcode:valid',
        () => {
            updateNextButtonVisibility();
        }
    );

    postcodeInput.addEventListener(
        'input',
        () => {
            formState.postcode = '';
            updateNextButtonVisibility();
        }
    );

    // CHANGE EVENTS
    document.addEventListener('change', (event) => {

        // STEP 1
        if (event.target.name === 'sector') {
            const selected = event.target;

            sectorOtherError.hidden = true;

            if (selected.value === 'other') {
                otherPanel.hidden = false;
                sectorOtherText.focus();
            } else {
                otherPanel.hidden = true;
                sectorOtherText.value = '';
            }

            formState.sector = selected.value;
            formState.sectorLabel =
                selected.dataset.label;

            updateNextButtonVisibility();

            tryAutoAdvance(
                1,
                selected,
                { allowOther: false }
            );
        }

        // STEP 2
        if (event.target.name === 'timeline') {
            const selected = event.target;

            formState.timeline = selected.value;
            formState.timelineLabel =
                selected.dataset.label;

            updateNextButtonVisibility();

            // Handle urgent immediately
            if (
                selected.value ===
                'urgent-within-72hrs'
            ) {
                form.hidden = true;
                result.hidden = true;
                urgentResult.hidden = false;

                return;
            }

            // Normal auto-advance
            tryAutoAdvance(2, selected);
        }
    });

    sectorOtherText.addEventListener(
        'input',
        () => {
            updateNextButtonVisibility();
        }
    );

    async function savePayload(payload) {
        const promise = await fetch(
            "/umbraco/api/booking/save",
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            }
        );

        if (promise.ok) {
            return promise.json();
        }

        return false;
    }

    // BUTTON HANDLERS
    document.addEventListener('click', (event) => {
        const nextButton =
            event.target.closest('[data-next]');

        const prevButton =
            event.target.closest('[data-prev]');

        // STOP Step 5 behaving like normal navigation
        if (currentStep === 5 && nextButton) {
            event.preventDefault();
            event.stopPropagation();

            const stepFive = document.querySelector(
                '.form-step[data-step="5"]'
            );

            const fields =
                stepFive.querySelectorAll(
                    'input, select, textarea'
                );

            let hasError = false;

            fields.forEach((field) => {
                const error =
                    document.getElementById(
                        `${field.id}-error`
                    );

                // Reset state
                field.removeAttribute(
                    'aria-invalid'
                );

                if (error) {
                    error.hidden = true;
                }

                if (!field.checkValidity()) {
                    hasError = true;

                    field.setAttribute(
                        'aria-invalid',
                        'true'
                    );

                    if (error) {
                        error.hidden = false;
                    }

                    if (
                        !stepFive.querySelector(
                            '[aria-invalid="true"]:focus'
                        )
                    ) {
                        field.focus();
                    }
                }
            });

            if (hasError) return;

            const payload =
                buildFullSubmissionPayload();

            savePayload(payload).then(
                (result) => {
                    if (result?.result) {
                        window.bookingPayload =
                            payload;

                        showThankYou();
                    } else {
                        showSaveError();

                        console.log(
                            "There was an error"
                        );
                    }
                }
            );

            return;
        }

        if (nextButton) {
            if (!validateCurrentStep()) {
                return;
            }

            showStep(currentStep + 1);
        }

        if (prevButton) {

            // Handle urgent screen back
            if (!urgentResult.hidden) {
                urgentResult.hidden = true;
                form.hidden = false;

                showStep(2);

                return;
            }

            // Normal step flow
            if (currentStep > 1) {
                showStep(currentStep - 1);
            }

            if (currentStep === 5) {
                showStep(4);

                return;
            }
        }
    });

    // STEP 4 → STEP 5 ONLY (EMAIL FLOW)
    const emailLink =
        document.getElementById('emailLink');

    emailLink?.addEventListener(
        'click',
        function (event) {
            event.preventDefault();
            showStep(5);
        }
    );

    form.addEventListener(
        'submit',
        (event) => {
            event.preventDefault();

            if (!validateCurrentStep()) {
                return;
            }

            /*
             * Build the complete Cal.com query string.
             *
             * This contains the booking responses plus
             * each saved tracking value as its own
             * URL parameter.
             */
            const queryString =
                buildQueryString(formState);

            const baseAgentUrl =
                postcodeInput.dataset.agentUrl;

            const getOnlineAgentUrl =
                postcodeInput.dataset.agentOnlineUrl;

            // Handle query string joining safely
            const appendQuery = (url) => {
                if (!url) {
                    return '#';
                }

                const separator =
                    url.includes('?')
                        ? '&'
                        : '?';

                return (
                    url +
                    separator +
                    queryString
                );
            };

            // Site visit
            const finalVisitUrl =
                appendQuery(baseAgentUrl);

            // Online consultation
            const finalOnlineUrl =
                appendQuery(
                    getOnlineAgentUrl
                );

            // Apply URLs
            calVisitLink.href =
                finalVisitUrl;

            calConsultationLink.href =
                finalOnlineUrl;

            /*
             * Keep the complete tracking object in the
             * booking payload sent to our own endpoint.
             *
             * This is separate from the Cal.com URL,
             * where each tracking property is passed
             * individually.
             */
            const payload = {
                sector: formState.sector,
                timeline: formState.timeline,
                postcode: formState.postcode,

                email: formState.email,
                fullName: formState.fullName,
                companyName: formState.companyName,
                additionalMessage: formState.additionalMessage,

                tracking:
                    buildTrackingPayload()
            };

            console.group("Booking Payload");
            console.table(payload);
            console.log(payload);
            console.groupEnd();

            console.log(
                "Cal.com visit URL:",
                finalVisitUrl
            );

            console.log(
                "Cal.com consultation URL:",
                finalOnlineUrl
            );

            showStep(4);
        }
    );

    if (
        document.querySelector(".dialog-close")
    ) {
        const closeDialog =
            document.querySelector(
                ".dialog-close"
            );

        closeDialog.addEventListener(
            'click',
            resetFormFlow
        );
    }

    showStep(1);

    const closeDialogButton =
        document.querySelector(
            '.dialog-close'
        );

    if (closeDialogButton) {
        closeDialogButton.addEventListener(
            'click',
            () => {
                resetFormFlow();
            }
        );
    }

    const restartButton =
        document.querySelector(
            '[data-restart]'
        );

    if (restartButton) {
        restartButton.addEventListener(
            'click',
            (event) => {
                event.preventDefault();
                resetFormFlow();
            }
        );
    }
}